<template>
  <div class="general-information">

    <AppText
        size="14"
        line-height="26"
        weight="700"
        class="color-text mb-20"
    >
      Asosiy malumotlar
    </AppText>

    <div class="cabinet__content">

      <div class="grid-block mb-10"
           style="max-width: 660px"
      >
        <div class="cabinet__content-item">
          <BaseInput label="Ism" v-model="user.firstName"
                     type="text"
                     vid="name"
                     rules="required|max:255"
          />
        </div>

        <div class="cabinet__content-item">
          <BaseInput label="Familiya" v-model="user.lastName"
                     type="text"
                     vid="name"
                     rules="required|max:255"
          />
        </div>

        <div class="cabinet__content-item">
          <BaseInput label="Login"
                     type="text"
                     vid="name"
                     rules="required|max:255"
                     v-model="user.login"/>
        </div>

      </div>

      <AppText
          size="14"
          line-height="26"
          weight="700"
          class="color-text mb-20"
      >
        Parolni o'zgartirish
      </AppText>

      <div class="grid-block mb-20"
           style="max-width: 660px"
      >

        <div class="cabinet__content-item">
          <BaseInput v-model="password"
                     type="text"
                     vid="name"
                     rules="required|max:255"
                     label="Eski parol"
          >
            <template #append>
              <img src="/icons/eye.svg" style="padding: 10px 20px" alt="">
            </template>
          </BaseInput>
        </div>

        <div class="cabinet__content-item">
          <BaseInput v-model="newPassword"
                     type="text"
                     vid="name"
                     rules="required|max:255"
                     label="Yangi parol"
          >
            <template #append>
              <img src="/icons/eye.svg" style="padding: 10px 20px" alt="">
            </template>
          </BaseInput>
        </div>

      </div>

      <AppButton sides="20" theme="secondary" @click="updateProfile">
        O'zgarishlarni saqlash
      </AppButton>


    </div>


  </div>
</template>

<script>
import BaseInput from "../../../components/shared-components/BaseInput";
import AppButton from "../../../components/shared-components/AppButton";
import {mapGetters} from "vuex";

export default {
  name: "general-information",
  components: {AppButton, BaseInput},
  data() {
    return {
      login: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      password: '',
      newPassword: '',
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    updateProfile() {
      let form = new FormData;
      form.append("FirstName", this.user.firstName);
      form.append("LastName", this.user.lastName);
      form.append("MiddleName", this.user.middleName);
      form.append("Email", this.user.email);
      form.append("Telefon", this.user.telefon);
      form.append("PhotoFile", this.user.photo);
      this.$api.put('Admin/Management/profile', form)
          .then(res => {
            if (!res.error && res.statusCode === 200) {
              this.user = res.result;
              this.successNotification("Saqlandi");
            }
          })
    },
  }
}
</script>

<style lang="scss" scoped>


</style>
